import React from 'react'
import Header from './users/Header'
import Footer from './users/Footer'
import Landing from './users/Landing'
import NavHeader from './users/NavHeader'

const Users = () => {
  return (
    <div className="antialiased bg-primary md:block md:bg-indigo-50" style={{ backgroundImage: `url('/images/bg-body.png')` }} relative>
        <NavHeader />
      <div className="max-w-[600px] mx-auto min-h-screen bg-slate-100 shadow-2xl">
        <Header />
        <Landing />
      </div>
        <Footer />
    </div>
  )
}

export default Users
